import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import PublicHeader from '../components/Header/PublicHeader';
import PublicFooter from '../components/Footer/PublicFooter';
import Button from '../components/ui/Button';
import './BillingActivate.css';

const BillingActivate = () => {
  const { tenant, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <>
      <PublicHeader />
      <section className="activate-page-wrapper">
        <div className="activate-card">
          <div className="activate-icon">💳</div>
          <h1 className="activate-title">Subscription Activation Required</h1>
          <p className="activate-text">
            Your account ({tenant?.email}) is approved. To activate full vault tokenization and API access, please choose a subscription plan.
          </p>

          <div className="activate-actions">
            <Button
              variant="primary"
              onClick={() => navigate('/plans')}
            >
              Choose Plan & Activate
            </Button>
            <Button
              variant="secondary"
              onClick={logout}
            >
              Sign Out
            </Button>
          </div>

          <div className="activate-footer-note">
            Have questions about billing? Reach out to{' '}
            <a href="mailto:billing@vaultize.com">billing@vaultize.com</a>
          </div>
        </div>
      </section>
      <PublicFooter />
    </>
  );
};

export default BillingActivate;
